import React, { useState, useEffect } from "react"
import styled from "styled-components"

export default function Panel({ showPanel, setShowPanel, content }) {
  const [counter, setCounter] = useState(0)

  useEffect(() => {
    if (counter < 100) {
      setTimeout(() => {
        setCounter(pre => pre + 1)
      }, 1000 / 120)
    }
  }, [counter])

  useEffect(() => {
    if (showPanel === "close" || showPanel === "loading") {
      setCounter(0)
    }
  }, [showPanel])

  // useEffect(() => {
  //   if (showPanel !== "close") {
  //     document.body.style.overflow = "hidden"
  //     return
  //   }
  //   document.body.style.overflow = "auto"
  // }, [showPanel])

  return (
    <BG className={showPanel}>
      <ShadowBG
        onClick={() => {
          setShowPanel("close")
        }}
      />
      <Wrapper className="Wrapper">
        <CancelBtnWrapper>
          <CancelBtn
            onClick={() => {
              setShowPanel("close")
            }}
          />
        </CancelBtnWrapper>
        {content}
      </Wrapper>
      <LoadingWrapper
        className={
          showPanel === "result" ? "LoadingWrapper clear" : "LoadingWrapper"
        }
      >
        <Loading className="Loading">
          <div></div>
          <div></div>
        </Loading>
        <Number className="Number">{counter}%</Number>
      </LoadingWrapper>
    </BG>
  )
}

const BG = styled.div`
  position: fixed;
  background-color: #0000004d;
  z-index: 30;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(3px);
  transition: 0.3s;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &.open {
    width: 100%;
    height: 100%;
  }

  &.close {
    opacity: 0;
    overflow: hidden;
    .Wrapper {
      width: 1px;
      min-height: 0;
      overflow: hidden;
      padding: 0;
      opacity: 0;
    }
  }
  &.send {
    width: 100%;
    height: 100%;
    background-color: #000000c2;
    .Wrapper {
      animation: sendNFT 3s forwards;
    }
    @keyframes sendNFT {
      40% {
        width: 1px;
        min-height: auto;
        height: auto;
        overflow: hidden;
        padding: 0;
        transform: translate(0, 0);
        background-color: #00fff0;
      }
      50% {
        width: 1px;
        min-height: auto;
        height: auto;
        overflow: hidden;
        padding: 0;
        transform: translate(0, -100vh);
      }
      100% {
        width: 1px;
        min-height: auto;
        height: auto;
        overflow: hidden;
        padding: 0;
        transform: translate(0, -100vh);
      }
    }

    p,
    h3 {
      animation: color 1s forwards;
    }
    @keyframes color {
      40% {
        color: #00fff0;
      }
      80% {
        color: #00fff0;
      }
      100% {
        color: #fff;
      }
    }
  }
  &.loading {
    width: 100%;
    height: 100%;
    background-color: #000000c2;
    .Wrapper {
      width: 1px;
      min-height: auto;
      height: auto;
      overflow: hidden;
      padding: 0;
      transform: translate(0, -100vh);
    }
    .LoadingWrapper {
      opacity: 1;
    }
  }
  &.result {
    width: 100%;
    height: 100%;
    .Wrapper {
      animation: resultNFT 1s forwards;
      @keyframes resultNFT {
        0% {
          width: 1px;
          min-height: auto;
          height: auto;
          overflow: hidden;
          padding: 0;
          transform: translate(0, -100vh);
        }
        70% {
          width: 1px;
          min-height: auto;
          height: auto;
          overflow: hidden;
          padding: 0;
          transform: translate(0, 0);
        }
      }
    }
  }
`

const ShadowBG = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
`
const Wrapper = styled.div`
  position: relative;
  width: 350px;
  min-height: 200px;
  margin: 0 20px;
  /* min-width: 200px; */
  display: flex;
  border: 3px solid #00fff0;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.655);
  backdrop-filter: blur(100px);
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 60px 0 40px 0;
  transition: 0.3s;
  overflow: hidden;
  z-index: 5;
  box-shadow: 0 0 30px #00fff0;
`
const CancelBtnWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  /* background-color: #88888855; */
`

const CancelBtn = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  &::before,
  &::after {
    content: "";
    width: 16px;
    height: 2px;
    background-color: #00fff0;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    transform: rotate(45deg);
  }
  &::after {
    transform: rotate(135deg);
  }
`

const LoadingWrapper = styled.div`
  opacity: 0;
  transition: all 0.5s;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &.clear {
    .Loading {
      div {
        animation: lds-ripple-clear forwards 0.5s;
      }
    }
    .Number {
      opacity: 0;
    }
  }
`
const Loading = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  div {
    position: absolute;
    border: 4px solid #00fff0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      width: 100px;
      height: 100px;
      opacity: 0;
    }

    5% {
      width: 100px;
      height: 100px;
      opacity: 1;
    }
    100% {
      width: 300px;
      height: 300px;
      opacity: 0;
    }
  }
  @keyframes lds-ripple-clear {
    0% {
      width: 300px;
      height: 300px;
      opacity: 0;
    }

    5% {
      width: 300px;
      height: 300px;
      opacity: 1;
    }
    100% {
      width: 1000px;
      height: 1000px;
      opacity: 0;
    }
  }
`

const Number = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #00fff0;
  transition: all 0.2s;
`
